import type { ReactNode } from 'react';
import styled from 'styled-components';

import { LabelM } from 'atoms/typography';

const Root = styled.div`
  text-align: left;
`;

type Props = {
  name: string;
  status?: ReactNode;
};

export const ClubShopItemFooter = ({ name, status = null }: Props) => {
  return (
    <Root>
      {status}
      <LabelM color="var(--c-nd-600)">{name}</LabelM>
    </Root>
  );
};
